import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { SaleInvestmentProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const saleInvestment = createAsyncThunk(
	'myInvestments/saleInvestment',
	(data: SaleInvestmentProps, { rejectWithValue }) =>
		asyncPayloadCreator(data, { rejectWithValue }, MyInvestmentsService.saleInvestment),
);
